import React from 'react';

import ThemeConsumer from './ThemeConsumer';
import ThemeProvider from './ThemeProvider';

const withTheme = WrappedComponent => {
  return props => (
    <ThemeProvider>
      <ThemeConsumer>{theme => <WrappedComponent theme={theme} {...props} />}</ThemeConsumer>
    </ThemeProvider>
  );
};

export default withTheme;
